import { useNavigate } from "react-router-dom";

export function useStepNavigate() {
  const navigate = useNavigate();

  return (to, options) => {
    if (typeof to === "string") {
      localStorage.setItem("step_page", to.replace(/^\//, "")); // pl. "/Meretlap" -> "Meretlap"
    }
    navigate(to, options);
  };
}
